export default "__VITE_ASSET__Cab2LV8m__"